import { Badge } from '@/components/ui/badge'
import { ApplicationResponseDTOStatus as ApplicationStatus  } from '@/utils/api/membership-service/models'

const STATUS_META: Record<ApplicationStatus, { label: string; variant: React.ComponentProps<typeof Badge>['variant'] }> = {
  [ApplicationStatus.PENDING]: { label: 'Pending', variant: 'outline' },
  [ApplicationStatus.APPROVED]: { label: 'Approved', variant: 'secondary' },
  [ApplicationStatus.REJECTED]: { label: 'Rejected', variant: 'destructive' },
  [ApplicationStatus.RENEWED]: { label: 'Renewed', variant: 'success' },
}

export function ApplicationStatusBadge({ status }: { status: ApplicationStatus }) {
  const meta = STATUS_META[status] ?? { label: status, variant: 'outline' }
  return (
    <Badge variant={meta.variant} className="uppercase tracking-wide">
      {meta.label}
    </Badge>
  )
}

